import { useEffect } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import Lenis from 'lenis';

export const Reveal = ({ children, className, delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div className={className} initial={reduced ? false : { opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-30px' }} transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }} {...props}>{children}</motion.div>;
};

export const SmoothScroll = () => {
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return;
    const lenis = new Lenis({ autoRaf: true, duration: 1.05, smoothWheel: true, syncTouch: false, anchors: { offset: -24 } });
    return () => lenis.destroy();
  }, [reduced]);
  return null;
};